import React from "react";
import classnames from "classnames";

import { groupBy } from "@formant/core/common/groupBy";
import { IValidation } from "@formant/core/model/IValidation";

import { ITab } from "./ITab";
import { TabButton } from "./TabButton";
import { TabButtonGroup } from "./TabButtonGroup";
import * as styles from "./TabButtons.scss";

export interface ITabButtonsProps {
    mode: "top" | "side";
    tabs: ITab[];
    selected: string;
    className?: string;
    onSelected: (name: string) => void;
    validation?: IValidation;
}

export function TabButtons(props: ITabButtonsProps) {
    const { mode, tabs, selected, className, onSelected, validation } = props;

    const newTabs = tabs;

    if (tabs.length <= 1) {
        return null;
    }

    const groups = newTabs.some(_ => _.group)
        ? [...groupBy(tabs, ({ group }) => group || 0).entries()].map(_ => _[1])
        : [newTabs];

    return (
        <div
            className={classnames(
                styles["tab-buttons"],
                styles[mode],
                className,
            )}
        >
            {groups.map((group, index) => (
                <TabButtonGroup key={index} mode={mode}>
                    {group.map(({ name, icon, validationKeys }) => {
                        const validationError =
                            (validationKeys &&
                                validation &&
                                Object.keys(validation).some(field =>
                                    validationKeys.some(
                                        _ =>
                                            field === _ ||
                                            field.startsWith(`${_}.`),
                                    ),
                                )) ||
                            false;
                        return (
                            <TabButton
                                key={name}
                                mode={mode}
                                name={name}
                                icon={icon}
                                selected={name === selected}
                                onSelected={onSelected}
                                validationError={validationError}
                            />
                        );
                    })}
                </TabButtonGroup>
            ))}
        </div>
    );
}
